import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/lay',
    name: 'lay',
    component:  () => import('../views/element/LayView.vue'),
    children:[
      {
        path: '/emp',
        name: 'emp',
        component:  () => import('../views/element/ElementView.vue')
      },
      {
        path: '/new',
        name: 'new',
        component:  () => import('../views/element/NewProblem.vue')
      },
      {
        path: '/type',
        name: 'type',
        component:  () => import('../views/element/TypeView.vue')
      },
    ]
  },
        {
        path: '/pointsGoods1',
        name: 'pointsGoods1',
        component:  () => import('../views/element/PointsGoods1View.vue')
      },
      {
        path: '/xianshi',
        name: 'xianshi',
        component:  () => import('../views/element/XianShiMallView.vue')
      },
      {
        path: '/MyAddress',
        name: 'MyAddress',
        component:  () => import('../views/element/MyAddressView.vue')
      },
      {
        path: '/pointsCode',
        name: 'pointsCode',
        component:  () => import('../views/element/PointsCodeView.vue')
      },

    {
    path: '/houtai',
    name: 'houtai',
    component:  () => import('../views/element/HoutaiLayView.vue'),
    children:[
      {
        path: '/salesClerk',
        name: 'salesClerk',
        component:  () => import('../views/element/SalesClerkView.vue')
      },
      {
        path: '/sales',
        name: 'sales',
        component:  () => import('../views/element/SalesmanView.vue')
      },
            {
        path: '/category',
        name: 'category',
        component:  () => import('../views/element/CategoryView.vue')
      },
      {
        path: '/goods',
        name: 'goods',
        component:  () => import('../views/element/GoodsView.vue')
      },
      {
        path: '/pointsGoods',
        name: 'pointsGoods',
        component:  () => import('../views/element/PointsGoodsView.vue')
      },
        {
    path: '/order',
    name: 'order',
    component:  () => import('../views/element/OrderView.vue')
  },
  {
    path: '/carousel',
    name: 'carousel',
    component:  () => import('../views/element/CarouselView.vue')
  },
  {
    path: '/address',
    name: 'address',
    component:  () => import('../views/element/AddressView.vue')
  },
          {
    path: '/kehu',
    name: 'kehu',
    component:  () => import('../views/element/KehuView.vue')
  },
    ]
  },
      {
      path: '/test',
      name: 'test',
      component:  () => import('../views/element/TestView.vue')
    },
  {path: '/lay2',
  name: 'lay2',
  component:  () => import('../views/element/LayView2.vue'),
  children:[
    {
      path: '/enFirst',
      name: 'enFirst',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/element/EnFirstView.vue')
    },

    {
      path: '/enSolution',
      name: 'enSolution',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/element/EnSolutionView.vue')
    },
    {
      path: '/enCommon',
      name: 'enCommon',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/element/EnCommon.vue')
    },
    {
      path: '/enDetail',
      name: 'enDetail',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/element/EnDetailView.vue')
    },
    {
      path: '/new2',
      name: 'new2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/element/NewView.vue')
    },
  ]},
    {
      path: '/code',
      name: 'code',
      component:  () => import('../views/element/CodeView.vue')
    },
        {
      path: '/codeIndex',
      name: 'codeIndex',
      component:  () => import('../views/element/CodeIndexView.vue')
    },
    {
      path: '/fenleihuizong',
      name: 'fenleihuizong',
      component:  () => import('../views/element/FenleiHuizongView.vue')
    },
    {
      path: '/shopDetail',
      name: 'shopDetail',
      component:  () => import('../views/element/ShopDetailView.vue')
    },
{
      path: '/shopDetail1',
      name: 'shopDetail1',
      component:  () => import('../views/element/ShopDetailView1.vue')
    },
      {path: '/footer',
    name: 'footer',
    component:  () => import('../views/element/FooterView.vue'),
    children:[
  {
    path: '/shopMall',
    name: 'shopMall',
    component:  () => import('../views/element/ShoppingMallView.vue')
  },
  {
    path: '/shopCategory',
    name: 'shopCategory',
    component:  () => import('../views/element/ShopCategoryView.vue')
  },
  {
    path: '/shopCart',
    name: 'shopCart',
    component:  () => import('../views/element/ShopCartView.vue')
  },
    {
    path: '/my',
    name: 'my',
    component:  () => import('../views/element/Myview.vue')
  },

]},
  {
    path: '/goCartgory',
    name: 'goCartgory',
    component:  () => import('../views/element/GoCartgoryView.vue')
  },
                {
    path: '/orderDetail',
    name: 'orderDetail',
    component:  () => import('../views/element/OrderDetailView.vue')
  },
 {
    path: '/orderShop',
    name: 'orderShop',
    component:  () => import('../views/element/OrderShopView.vue')
  },
  {
    path: '/',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/element/LoginView.vue')
  },
  {
    path: '/after',
    name: 'after',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/element/AfterSaleView.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/element/SolutionView.vue')
  },

  
  {
    path: '/enFirst',
    name: 'enFirst',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/element/EnFirstView.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/element/DetailView.vue')
  },

  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/element/RegisterView.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
